import http from './http';

export default {
  all() {
    return http().get(`/v1/integrations`);
  },
  deleteIntegration(id) {
    return http().delete(`/v1/integrations/${id}`);
  },

  /**
   * MAILGUN INTEGRATION
   */
  setMailGunOutgoingEmailName(data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/emails/outgoing_email_name`, data);
  },
  verifyForwardingEmail(data) {
    return http().post(`/v1/emails/verify_forwarding_email`, data);
  },
}
